export enum ELoginEduDefaultForm {
    register = 'register',
    login = 'login',
}
